import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class ScrollService {

  constructor() { }

  scrollToTop(selector: string = 'ion-content') {
    const ionContent = document.querySelector(selector);
    if (ionContent && 'scrollToTop' in ionContent) {
      (ionContent as any).scrollToTop(0);
    }
  }

  scrollToBottom(selector: string = 'ion-content') {
    const ionContent = document.querySelector(selector);
    if (ionContent && 'scrollToBottom' in ionContent) {
      (ionContent as any).scrollToBottom(300);
    }
  }
}
